import React, { useState } from 'react';
import { Loader2, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { errMsg } from '@/services/staffAttendanceApi';
import { ewbApi } from '@/services/ewayBillApi';

/** Cancel within 24 hours of generation — reason + remark go to the GST portal. */
export const CancelEwbBox = ({ bill, reasons, onDone }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(reasons[0] || '');
  const [remark, setRemark] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = () => {
    setBusy(true);
    ewbApi.cancel(bill.id, { reason, remark })
      .then((b) => { toast.success(`E-way bill ${b.ewb_no} cancelled`); onDone(b); })
      .catch((e) => toast.error(errMsg(e, 'Cancel failed'))).finally(() => setBusy(false));
  };
  const portal = bill.route === 'portal';
  if (!open) {
    return <Button variant="outline" className="border-rose-300 text-rose-700 hover:bg-rose-50" onClick={() => setOpen(true)} data-testid="ewb-cancel-open">
      <XCircle className="w-4 h-4 mr-1" />{portal ? 'Mark cancelled (done on the portal)' : 'Cancel e-way bill'}</Button>;
  }
  return (
    <div className="w-full rounded-lg border border-rose-200 bg-rose-50 p-3 space-y-2" data-testid="ewb-cancel-box">
      <p className="text-sm text-rose-800">{portal ? 'Cancel the e-way bill on the GST portal first — this only records it in WMS. ' : ''}Cancelling can't be undone. You can make a new e-way bill for this document afterwards.</p>
      <select value={reason} onChange={(e) => setReason(e.target.value)} className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm" data-testid="ewb-cancel-reason">
        {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      <Textarea value={remark} onChange={(e) => setRemark(e.target.value)} maxLength={100} placeholder="Remark (required)" className="bg-white" data-testid="ewb-cancel-remark" />
      <div className="flex gap-2 justify-end">
        <Button variant="ghost" onClick={() => setOpen(false)} data-testid="ewb-cancel-back">Back</Button>
        <Button onClick={submit} disabled={busy || !remark.trim()} className="bg-rose-600 hover:bg-rose-700" data-testid="ewb-cancel-confirm">
          {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Confirm cancel
        </Button>
      </div>
    </div>
  );
};

export default CancelEwbBox;
